import { sendWebsocketMessage } from '../../../../../App';

export function removeSymbol(data) {
  if (data.symbol) {
    const message = {
      messageType: 'removeSymbol',
      removeSymbol: data,
    };
    sendWebsocketMessage(message);
  }
}
